// SOVAH Chat Widget (Horizon-friendly) — v29 storefront locale and compact welcome teaser
var SOVAH_CHAT_API = "https://sovah-ai-bwp4p48zg-lucvrielik-2449s-projects.vercel.app/api/chat";
var SOVAH_LOGO_URL = "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/Organic-Skincare-Sovah-GlutenFree-GoodSkin-GlowySkin-icon.png?v=1773160170";
var SOVAH_SUPPORT_URL = "https://sovahcare.com/pages/contact";
var SOVAH_QUIZ_URL = "https://sovahcare.com/pages/find-your-routine";
console.log("SOVAH chat v29 storefront locale and welcome teaser loaded");

(function () {
  const COPY = {
    en: {
      welcome:
        "Hello! Welcome to SOVAH.\nI’m your skincare assistant. I can help you choose the right products or guide you to the best routine for your skin.",
      teaserTitle: "Welcome to SOVAH",
      teaserText: "I’m your skincare assistant. Need help? Click here and ask your question.",
      teaserAria: "Open the SOVAH skincare assistant",
      dismissTeaserAria: "Close welcome message",
      quickPrimary: [
        {
          label: "Build my routine",
          prompt: "Which routine fits me best?",
          kind: "quiz",
        },
        {
          label: "What do I need?",
          prompt: "Can you recommend 1–2 products for my skin? I do not want a full routine.",
          kind: "products",
        },
      ],
      quickSecondary: [
        {
          label: "Target your concern",
          prompt: "I want help based on my main skin concern.",
        },
        {
          label: "Acne & breakouts",
          prompt: "Can you recommend 1–2 products for acne or breakouts? I do not want a full routine.",
        },
      ],
      inputPlaceholder: "Ask your skincare question…",
      send: "Send",
      title: "SOVAH Assistant",
      subtitle: "Personal skincare advice",
      openAria: "Open SOVAH chat",
      closeAria: "Close SOVAH chat",
      open: "Open",
      fallback:
        "Tell me your skin type, concern, or goal, and I’ll help from there.",
    },
    nl: {
      welcome:
        "Hi! Welkom bij SOVAH.\nIk ben je skincare assistant en help je graag met de juiste producten of routine voor jouw huid.",
      teaserTitle: "Welkom bij SOVAH",
      teaserText: "Ik ben je skincare assistant. Hulp nodig? Klik hier en stel je vraag.",
      teaserAria: "Open de SOVAH skincare assistant",
      dismissTeaserAria: "Sluit welkomstbericht",
      quickPrimary: [
        {
          label: "Routine opbouwen",
          prompt: "Welke routine past het best bij mij?",
          kind: "quiz",
        },
        {
          label: "Wat heb ik nodig?",
          prompt: "Kan je 1–2 producten aanraden voor mijn huid? Ik wil geen volledige routine.",
          kind: "products",
        },
      ],
      quickSecondary: [
        {
          label: "Kies op huidprobleem",
          prompt: "Ik wil hulp op basis van mijn belangrijkste huidprobleem.",
        },
        {
          label: "Acne & puistjes",
          prompt: "Kan je 1–2 producten aanraden voor acne of puistjes? Ik wil geen volledige routine.",
        },
      ],
      inputPlaceholder: "Stel je skincare vraag…",
      send: "Verstuur",
      title: "SOVAH Assistant",
      subtitle: "Persoonlijk skincare advies",
      openAria: "Open SOVAH chat",
      closeAria: "Sluit SOVAH chat",
      open: "Open",
      fallback:
        "Vertel me je huidtype, huidprobleem of doel, dan help ik je verder.",
    },
    de: {
      welcome:
        "Hallo! Willkommen bei SOVAH.\nIch bin dein Skincare Assistant und helfe dir, passende Produkte oder die richtige Routine für deine Haut zu finden.",
      teaserTitle: "Willkommen bei SOVAH",
      teaserText: "Ich bin dein Skincare Assistant. Brauchst du Hilfe? Klicke hier und stell deine Frage.",
      teaserAria: "SOVAH Skincare Assistant öffnen",
      dismissTeaserAria: "Willkommensnachricht schließen",
      quickPrimary: [
        {
          label: "Routine aufbauen",
          prompt: "Welche Routine passt am besten zu mir?",
          kind: "quiz",
        },
        {
          label: "Was brauche ich?",
          prompt: "Kannst du mir 1–2 Produkte für meine Haut empfehlen? Ich möchte keine komplette Routine.",
          kind: "products",
        },
      ],
      quickSecondary: [
        {
          label: "Nach Hautproblem wählen",
          prompt: "Ich möchte Hilfe basierend auf meinem wichtigsten Hautproblem.",
        },
        {
          label: "Akne & Pickel",
          prompt: "Kannst du mir 1–2 Produkte für Akne oder Pickel empfehlen? Ich möchte keine komplette Routine.",
        },
      ],
      inputPlaceholder: "Stelle deine Skincare-Frage…",
      send: "Senden",
      title: "SOVAH Assistant",
      subtitle: "Persönliche Skincare-Beratung",
      openAria: "SOVAH Chat öffnen",
      closeAria: "SOVAH Chat schließen",
      open: "Öffnen",
      fallback:
        "Sag mir kurz deinen Hauttyp oder dein Hautproblem, dann empfehle ich dir die passende Routine oder 1–2 Produkte.",
    },
  };

  const SOVAH_AUTO_OPEN_KEY = "sovah_chat_last_teaser_v29";
  const SOVAH_AUTO_OPEN_COOLDOWN = 60 * 60 * 1000;
  const SOVAH_TEASER_DELAY = 15 * 1000;
  const SOVAH_HISTORY_LIMIT = 24;
  const SOVAH_HISTORY_STORAGE_KEY = "sovah_chat_history_v2";
  const SOVAH_CONTEXT_STORAGE_KEY = "sovah_chat_context_v2";

  const SOVAH_ROUTINE_CARDS = [
    {
      match: ["Dry Skin Routine", "Dry & Dehydrated Skin Routine"],
      title: "Dry Skin Routine",
      url: "https://sovahcare.com/products/dry-dehydrated-skin-routine",
      image: "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/SOVAH_Dry_Dehydrated_Skin_Routine_Skincare_Set_for_Dry_and_Dehydrated_Skin.png?v=1776108066",
      price: "€144,95",
    },
    {
      match: ["Sensitive Skin Routine", "Sensitive & Reactive Skin Routine"],
      title: "Sensitive Skin Routine",
      url: "https://sovahcare.com/products/sensitive-reactive-skin-routine",
      image: "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/SOVAH_Sensitive_Reactive_Skin_Routine_Soothing_Skincare_for_Sensitive_and_Reactive_Skin.png?v=1776108959",
      price: "€144,95",
    },
    {
      match: ["Acne Skin Routine", "Clear & Balanced Skin Routine"],
      title: "Acne Skin Routine",
      url: "https://sovahcare.com/products/clear-balanced-skin-routine",
      image: "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/sovah-acne-routine-purifying-mousse-oil-free-hydrating-gel-acne-spot-care_a4fa3783-526d-4bd3-ae28-fbac40fb6a22.png?v=1780327241",
      price: "€99,95",
    },
    {
      match: ["Combination Skin Routine", "Combination Skin Balance Routine"],
      title: "Combination Skin Routine",
      url: "https://sovahcare.com/products/combination-skin-balance-routine",
      image: "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/sovah-combination-skin-balance-routine-purifying-mousse-hydrating-toner-niacinamide-gel-moisturiser.png?v=1780325388",
      price: "€89,95",
    },
    {
      match: ["Dull Skin Routine", "Glow & Radiance Routine"],
      title: "Dull Skin Routine",
      url: "https://sovahcare.com/products/glow-radiance-routine",
      image: "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/sovah-dull-skin-routine-micellar-cleansing-water-vitamin-c-serum-antioxidant-ginkgo-gel-booster-moisturising-day-cream.png?v=1780325781",
      price: "€124,95",
    },
    {
      match: ["Aging Skin Routine", "Firm & Smooth Skin Routine"],
      title: "Aging Skin Routine",
      url: "https://sovahcare.com/products/firm-smooth-skin-routine",
      image: "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/SOVAH_Firm_Smooth_Skin_Routine_Firming_Anti-Aging_Skincare_for_Mature_Skin.png?v=1776108992",
      price: "€159,95",
    },
    {
      match: ["Simple Normal Skin Routine"],
      title: "Simple Normal Skin Routine",
      url: "https://sovahcare.com/products/simple-daily-skincare-routine",
      image: "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/sovah-simple-normal-routine-micellar-cleansing-water-moisturising-day-cream_030fa985-7455-4c86-b1d4-56ee017330eb.png?v=1780326580",
      price: "€59,95",
    },
    {
      match: ["Normal Skin Routine", "Normal & Balanced Skin Routine"],
      title: "Normal Skin Routine",
      url: "https://sovahcare.com/products/normal-balanced-skin-routine",
      image: "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/sovah-normal-balanced-skin-routine-micellar-cleansing-water-hydrating-toner-niacinamide-gel-moisturiser.png?v=1780325164",
      price: "€79,95",
    },
    {
      match: ["Simple Sensitive Skin Routine"],
      title: "Simple Sensitive Skin Routine",
      url: "https://sovahcare.com/products/simple-sensitive-skin-routine",
      image: "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/sovah-micellar-cleansing-water-niacinamide-gel-moisturiser-skincare-duo.png?v=1780324703",
      price: "€59,95",
    },
    {
      match: ["Simple Oily Skin Routine"],
      title: "Simple Oily Skin Routine",
      url: "https://sovahcare.com/products/simple-oily-skin-routine",
      image: "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/sovah-purifying-mousse-oil-free-hydrating-gel-skincare-duo.png?v=1780324287",
      price: "€69,95",
    },
    {
      match: ["Simple Combination Skin Routine"],
      title: "Simple Combination Skin Routine",
      url: "https://sovahcare.com/products/simple-combination-skin-routine",
      image: "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/sovah-purifying-mousse-oil-free-hydrating-gel-skincare-duo.png?v=1780324287",
      price: "€69,95",
    },
    {
      match: ["Simple Aging Skin Routine"],
      title: "Simple Aging Skin Routine",
      url: "https://sovahcare.com/products/simple-aging-skin-routine",
      image: "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/sovah-micellar-cleansing-water-anti-age-day-cream-skincare-duo.png?v=1780324041",
      price: "€59,95",
    },
    {
      match: ["Simple Acne Routine"],
      title: "Simple Acne Routine",
      url: "https://sovahcare.com/products/simple-acne-routine",
      image: "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/sovah-purifying-mousse-niacinamide-gel-moisturiser-skincare-duo.png?v=1780323659",
      price: "€69,95",
    },
    {
      match: ["Simple Dull Skin Routine"],
      title: "Simple Dull Skin Routine",
      url: "https://sovahcare.com/products/simple-dull-skin-routine",
      image: "https://cdn.shopify.com/s/files/1/1007/2974/9842/files/sovah-micellar-cleansing-water-moisturising-day-cream-hydrating-skincare-duo.png?v=1780323397",
      price: "€59,95",
    },
  ];

  function actionsHaveRoutineCard(actions = []) {
    return Array.isArray(actions) && actions.some((a) =>
      a &&
      (a.type === "ROUTINE_CARD" || a.kind === "ROUTINE_CARD" || a.routineCard)
    );
  }

  function findRoutineCardFromReply(replyText) {
    const text = safeText(replyText).toLowerCase();
    if (!text) return null;

    return SOVAH_ROUTINE_CARDS.find((routine) =>
      routine.match.some((name) => text.includes(name.toLowerCase()))
    ) || null;
  }

  function appendRoutineCardFallback(container, replyText, actions = [], lang = "en") {
    if (actionsHaveRoutineCard(actions)) return;

    const routine = findRoutineCardFromReply(replyText);
    if (!routine) return;

    appendActions(
      container,
      [
        {
          type: "ROUTINE_CARD",
          label: lang === "nl" ? "Bekijk routine" : lang === "de" ? "Routine ansehen" : "View routine",
          title: routine.title,
          url: routine.url,
          image: routine.image,
          price: routine.price,
        },
      ],
      lang
    );
  }


  function el(tag, attrs = {}, children = []) {
    const node = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => {
      if (k === "class") node.className = v;
      else if (k === "html") node.innerHTML = v;
      else node.setAttribute(k, v);
    });
    children.forEach((c) => node.appendChild(c));
    return node;
  }

  function safeText(t) {
    return (t || "").toString();
  }

  function normalize(text) {
    return safeText(text).toLowerCase().trim();
  }

  function scoreLang(text) {
    const t = normalize(text);

    const dutchSignals = [
      "ik", "mijn", "huid", "droog", "droge", "vette", "vet", "gevoelig",
      "welke", "wat", "past", "bij", "mij", "puistjes", "acne",
      "routine", "dagcrème", "dagcreme", "nachtcrème", "nachtcreme",
      "serum", "reiniger", "toner", "help", "advies", "meer", "wil", "heb",
      "last van", "fijne lijntjes", "gevoelige huid", "product", "producten",
      "hoe gebruik", "combineren", "aanraden", "oudere huid", "niets voor acne",
      "voor droge huid", "voor puistjes", "huidprobleem", "wat heb ik nodig"
    ];

    const englishSignals = [
      "my", "skin", "dry", "oily", "sensitive", "which", "what", "fits",
      "best", "breakouts", "hydration", "routine", "serum",
      "cleanser", "toner", "help", "advice", "i want", "i have",
      "fine lines", "product", "products", "moisturiser", "moisturizer",
      "how do i use", "combine", "recommend", "older skin", "nothing for acne",
      "for dry skin", "for breakouts", "what do i need", "concern"
    ];

    const germanSignals = [
      "ich", "meine", "mein", "haut", "trockene", "trocken", "fettige",
      "empfindliche", "empfindlich", "welche", "was", "passt", "zu mir",
      "pickel", "akne", "routine", "produkt", "produkte", "brauche",
      "empfehlen", "beratung", "hautproblem", "unreinheiten", "feuchtigkeit",
      "glow", "fahle haut", "reife haut", "feine linien", "verwenden",
      "kombinieren", "keine komplette routine"
    ];

    const nlCount = dutchSignals.filter((w) => t.includes(w)).length;
    const enCount = englishSignals.filter((w) => t.includes(w)).length;
    const deCount = germanSignals.filter((w) => t.includes(w)).length;

    return { nl: nlCount, en: enCount, de: deCount };
  }

  function detectLang(text, previousLang = "en") {
    const t = normalize(text);

    const strongDutchSignals = [
      "hoe gebruik ik",
      "welke routine",
      "ik wil",
      "droge huid",
      "puistjes",
      "oudere huid",
      "wat raad je aan",
      "niets voor acne",
      "kan je",
      "ik wil geen volledige routine",
      "wat heb ik nodig",
      "huidprobleem"
    ];

    const strongEnglishSignals = [
      "how do i use",
      "which routine",
      "i want",
      "dry skin",
      "breakouts",
      "older skin",
      "what do you recommend",
      "nothing for acne",
      "can you",
      "i do not want a full routine",
      "what do i need",
      "skin concern"
    ];

    const strongGermanSignals = [
      "wie verwende ich",
      "welche routine",
      "ich möchte",
      "ich will",
      "trockene haut",
      "pickel",
      "akne",
      "was empfiehlst du",
      "kannst du",
      "ich möchte keine komplette routine",
      "was brauche ich",
      "hautproblem"
    ];

    const hasStrongNl = strongDutchSignals.some((w) => t.includes(w));
    const hasStrongEn = strongEnglishSignals.some((w) => t.includes(w));
    const hasStrongDe = strongGermanSignals.some((w) => t.includes(w));

    if (hasStrongDe && !hasStrongNl && !hasStrongEn) return "de";
    if (hasStrongEn && !hasStrongNl && !hasStrongDe) return "en";
    if (hasStrongNl && !hasStrongEn && !hasStrongDe) return "nl";

    const score = scoreLang(text);
    if (score.de > 0 && score.nl === 0 && score.en === 0) return "de";
    if (score.en > 0 && score.nl === 0 && score.de === 0) return "en";
    if (score.nl > 0 && score.en === 0 && score.de === 0) return "nl";

    const scores = [
      ["nl", score.nl || 0],
      ["en", score.en || 0],
      ["de", score.de || 0],
    ].sort((a, b) => b[1] - a[1]);

    if (scores[0][1] === 0 || scores[0][1] === scores[1][1]) return previousLang;
    return scores[0][0];
  }

  function renderBotHtml(text) {
    return safeText(text)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
      .replace(/\n/g, "<br>");
  }

  function createAvatar() {
    const avatar = document.createElement("div");
    avatar.className = "sovah-avatar";
    avatar.innerHTML = `<img src="${SOVAH_LOGO_URL}" alt="SOVAH logo" />`;
    return avatar;
  }

  function appendMsg(container, text, who = "bot") {
    const row = document.createElement("div");
    row.className = `sovah-msg-row ${who}`;

    if (who === "bot") {
      row.appendChild(createAvatar());
    }

    const msg = document.createElement("div");
    msg.className = `sovah-msg ${who}`;

    if (who === "bot") {
      msg.innerHTML = renderBotHtml(text);
    } else {
      msg.textContent = safeText(text);
    }

    row.appendChild(msg);
    container.appendChild(row);
    container.scrollTop = container.scrollHeight;

    return row;
  }

  function appendTyping(container) {
    const row = document.createElement("div");
    row.className = "sovah-msg-row bot";

    row.appendChild(createAvatar());

    const wrap = document.createElement("div");
    wrap.className = "sovah-msg bot";

    const t = document.createElement("div");
    t.className = "sovah-typing";
    t.innerHTML =
      '<span class="sovah-dot"></span><span class="sovah-dot"></span><span class="sovah-dot"></span>';

    wrap.appendChild(t);
    row.appendChild(wrap);
    container.appendChild(row);
    container.scrollTop = container.scrollHeight;

    return row;
  }

  function isQuizAction(action) {
    if (!action) return false;

    const label = (action.label || "").toLowerCase();
    const url = (action.url || "").toLowerCase();

    return (
      url === SOVAH_QUIZ_URL.toLowerCase() ||
      label.includes("quiz") ||
      label.includes("find your routine") ||
      label.includes("start de quiz") ||
      label.includes("start quiz") ||
      label.includes("build my routine")
    );
  }

  function appendActions(container, actions = [], lang = "en") {
    if (!actions || !actions.length) return;

    const normalWrap = el("div", { class: "sovah-actions" });

    actions.forEach((a) => {
      if (!a) return;

      if (a.routineCard && typeof a.routineCard === "object") {
        a = { type: "ROUTINE_CARD", ...a.routineCard };
      }

      if (!a.type && !a.kind) return;

      if ((a.type === "ROUTINE_CARD" || a.kind === "ROUTINE_CARD") && a.url) {
        const card = el("div", { class: "sovah-routine-card" });

        if (a.image) {
          const imageLink = el("a", {
            class: "sovah-routine-card-image-link",
            href: a.url,
            target: "_blank",
            rel: "noopener",
            "aria-label": a.title || a.label || COPY[lang].open,
          });

          const img = el("img", {
            class: "sovah-routine-card-image",
            src: a.image,
            alt: a.title || "SOVAH routine",
            loading: "lazy",
          });

          imageLink.appendChild(img);
          card.appendChild(imageLink);
        }

        const content = el("div", { class: "sovah-routine-card-content" });

        const title = el("div", { class: "sovah-routine-card-title" });
        title.textContent = a.title || a.label || "SOVAH routine";
        content.appendChild(title);

        if (a.price) {
          const price = el("div", { class: "sovah-routine-card-price" });
          price.textContent = a.price;
          content.appendChild(price);
        }

        const button = el("a", {
          class: "sovah-action sovah-routine-card-button",
          href: a.url,
          target: "_blank",
          rel: "noopener",
        });
        button.textContent = a.label || (lang === "nl" ? "Bekijk routine" : "View routine");
        content.appendChild(button);

        card.appendChild(content);
        container.appendChild(card);
        return;
      }

      if (a.type === "OPEN_URL" && a.url) {
        const className = isQuizAction(a)
          ? "sovah-action sovah-quiz-action"
          : "sovah-action";

        const link = el("a", {
          class: className,
          href: a.url,
          target: "_blank",
          rel: "noopener",
        });
        link.textContent = a.label || COPY[lang].open;
        normalWrap.appendChild(link);
      }
    });

    if (normalWrap.children.length) {
      container.appendChild(normalWrap);
    }

    container.scrollTop = container.scrollHeight;
  }


  function buildRoutineCardElement(routine, lang = "en") {
    const card = el("div", { class: "sovah-routine-card sovah-routine-card-hard" });

    if (routine.image) {
      const imageLink = el("a", {
        class: "sovah-routine-card-image-link",
        href: routine.url,
        target: "_blank",
        rel: "noopener",
        "aria-label": routine.title || "SOVAH routine",
      });

      const img = el("img", {
        class: "sovah-routine-card-image",
        src: routine.image,
        alt: routine.title || "SOVAH routine",
        loading: "lazy",
      });

      imageLink.appendChild(img);
      card.appendChild(imageLink);
    }

    const content = el("div", { class: "sovah-routine-card-content" });

    const title = el("div", { class: "sovah-routine-card-title" });
    title.textContent = routine.title || "SOVAH routine";
    content.appendChild(title);

    if (routine.price) {
      const price = el("div", { class: "sovah-routine-card-price" });
      price.textContent = routine.price;
      content.appendChild(price);
    }

    const button = el("a", {
      class: "sovah-action sovah-routine-card-button",
      href: routine.url,
      target: "_blank",
      rel: "noopener",
    });
    button.textContent = lang === "nl" ? "Bekijk routine" : "View routine";
    content.appendChild(button);

    card.appendChild(content);
    return card;
  }

  function appendRoutineCardFromText(container, text, lang = "en") {
    const routine = findRoutineCardFromReply(text);
    if (!routine) return;

    const key = `routine-card-${routine.title}`;
    if (container.querySelector(`[data-sovah-card-key="${key}"]`)) return;

    const card = buildRoutineCardElement(routine, lang);
    card.setAttribute("data-sovah-card-key", key);
    container.appendChild(card);
    container.scrollTop = container.scrollHeight;
  }


  function hasAny(text, words) {
    return words.some((word) => text.includes(word));
  }

  function detectIntent(text) {
    const t = normalize(text);

    if (
      hasAny(t, [
        "breakout", "breakouts", "acne", "blemish", "blemishes",
        "spots", "pimples", "blackheads", "clogged pores",
        "puistjes", "onzuiverheden", "mee eters", "mee-eters"
      ])
    ) return "breakouts";

    if (
      hasAny(t, [
        "dry", "dehydrated", "tight", "hydration",
        "flaky", "rough", "moisture",
        "droog", "droge huid", "uitgedroogd", "hydratatie", "vochttekort"
      ])
    ) return "dry";

    if (
      hasAny(t, [
        "anti-age", "anti age", "anti aging", "anti-aging", "fine lines",
        "firmness", "aging", "ageing", "wrinkles", "smooth",
        "rimpels", "fijne lijntjes", "stevigheid", "older skin", "oudere huid"
      ])
    ) return "antiage";

    if (
      hasAny(t, [
        "recommend", "what should i use", "what do i need", "help me choose",
        "wat raad je aan", "wat moet ik gebruiken", "help me kiezen", "wat heb ik nodig"
      ])
    ) return "recommend";

    if (
      hasAny(t, [
        "routine", "fits me", "best for me",
        "welke routine", "past bij mij", "beste routine", "routine opbouwen"
      ])
    ) return "routine";

    if (
      hasAny(t, [
        "concern", "skin concern", "target your concern",
        "huidprobleem", "kies op huidprobleem"
      ])
    ) return "concern";

    return null;
  }

  function buildQuizRedirect(lang) {
    return {
      reply:
        lang === "nl"
          ? "Voor uitgebreider routine-advies kun je ook onze skincare quiz gebruiken.\n\nDaar helpen we je stap voor stap naar de beste match voor jouw huid."
          : "For more complete routine advice, you can also use our skincare quiz.\n\nThere we guide you step by step to the best match for your skin.",
      actions: [
        {
          type: "OPEN_URL",
          label: lang === "nl" ? "Start de quiz" : "Start quiz",
          url: SOVAH_QUIZ_URL,
        },
      ],
      lang,
    };
  }

  function fallbackFlow(userText, lang = "en") {
    const kind = detectIntent(userText);

    if (kind === "routine") {
      return buildQuizRedirect(lang);
    }

    if (kind === "concern") {
      return {
        reply:
          lang === "nl"
            ? "Vertel me wat je belangrijkste huidprobleem is, zoals droogte, puistjes, gevoeligheid of een doffe huid."
            : "Tell me your main skin concern, such as dryness, breakouts, sensitivity, or dull skin.",
        actions: [],
        lang,
      };
    }

    if (kind === "dry") {
      return {
        reply:
          lang === "nl"
            ? "Vertel me of je liever 1–2 producten wilt of een volledige routine voor droge huid."
            : "Tell me whether you'd prefer 1–2 products or a full routine for dry skin.",
        actions: [],
        lang,
      };
    }

    if (kind === "breakouts") {
      return {
        reply:
          lang === "nl"
            ? "Vertel me of je liever 1–2 producten wilt of een volledige routine voor acne of puistjes."
            : "Tell me whether you'd prefer 1–2 products or a full routine for acne or breakouts.",
        actions: [],
        lang,
      };
    }

    if (kind === "antiage") {
      return {
        reply:
          lang === "nl"
            ? "Vertel me of je liever 1–2 producten wilt of een complete routine voor fijne lijntjes en stevigheid."
            : "Tell me whether you’d prefer 1–2 products or a full routine for fine lines and firmness.",
        actions: [],
        lang,
      };
    }

    return {
      reply: COPY[lang].fallback,
      actions: [
        {
          type: "OPEN_URL",
          label: lang === "nl" ? "Contact opnemen" : "Contact support",
          url: SOVAH_SUPPORT_URL,
        },
      ],
      lang,
    };
  }

  function createHistoryStore() {
    let items = [];

    try {
      const stored = JSON.parse(sessionStorage.getItem(SOVAH_HISTORY_STORAGE_KEY) || "[]");
      if (Array.isArray(stored)) {
        items = stored
          .filter((item) => typeof item === "string")
          .slice(-SOVAH_HISTORY_LIMIT);
      }
    } catch (error) {
      console.warn("SOVAH history restore failed:", error);
    }

    function persist() {
      try {
        sessionStorage.setItem(
          SOVAH_HISTORY_STORAGE_KEY,
          JSON.stringify(items.slice(-SOVAH_HISTORY_LIMIT))
        );
      } catch (error) {
        console.warn("SOVAH history save failed:", error);
      }
    }

    return {
      pushUser(text) {
        items.push(`User: ${text}`);
        while (items.length > SOVAH_HISTORY_LIMIT) items.shift();
        persist();
      },
      pushBot(text) {
        items.push(`Assistant: ${text}`);
        while (items.length > SOVAH_HISTORY_LIMIT) items.shift();
        persist();
      },
      getAll() {
        return items.slice();
      },
      clear() {
        items.length = 0;
        persist();
      },
    };
  }

  function createContextStore() {
    let value = {
      product_ids: [],
      bundle_ids: [],
      intent: null,
    };

    try {
      const stored = JSON.parse(
        sessionStorage.getItem(SOVAH_CONTEXT_STORAGE_KEY) || "null"
      );

      if (stored && typeof stored === "object") {
        value = {
          product_ids: Array.isArray(stored.product_ids)
            ? stored.product_ids.filter((item) => typeof item === "string").slice(0, 3)
            : [],
          bundle_ids: Array.isArray(stored.bundle_ids)
            ? stored.bundle_ids.filter((item) => typeof item === "string").slice(0, 2)
            : [],
          intent: typeof stored.intent === "string" ? stored.intent : null,
        };
      }
    } catch (error) {
      console.warn("SOVAH context restore failed:", error);
    }

    function persist() {
      try {
        sessionStorage.setItem(SOVAH_CONTEXT_STORAGE_KEY, JSON.stringify(value));
      } catch (error) {
        console.warn("SOVAH context save failed:", error);
      }
    }

    return {
      get() {
        return {
          product_ids: value.product_ids.slice(),
          bundle_ids: value.bundle_ids.slice(),
          intent: value.intent,
        };
      },
      set(next) {
        if (!next || typeof next !== "object") return;

        value = {
          product_ids: Array.isArray(next.product_ids)
            ? next.product_ids.filter((item) => typeof item === "string").slice(0, 3)
            : [],
          bundle_ids: Array.isArray(next.bundle_ids)
            ? next.bundle_ids.filter((item) => typeof item === "string").slice(0, 2)
            : [],
          intent: typeof next.intent === "string" ? next.intent : null,
        };

        persist();
      },
      clear() {
        value = {
          product_ids: [],
          bundle_ids: [],
          intent: null,
        };
        persist();
      },
    };
  }

  async function callBackend(message, sessionId, historyStore, contextStore, lang) {
    try {
      let history = historyStore.getAll();

      // The caller already placed the current user message in the UI/history.
      // Remove that last duplicate before sending, because `message` is sent separately.
      const duplicateCurrentMessage = `User: ${message}`;
      if (history[history.length - 1] === duplicateCurrentMessage) {
        history = history.slice(0, -1);
      }

      const res = await fetch(SOVAH_CHAT_API, {
        method: "POST",
        mode: "cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message,
          sessionId,
          history,
          context: contextStore.get(),
          lang,
        }),
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const data = await res.json();

      if (!data || !data.reply) {
        throw new Error("Invalid JSON response");
      }

      if (data.context) {
        contextStore.set(data.context);
      }

      return {
        reply: data.reply,
        actions: Array.isArray(data.actions) ? data.actions : [],
        lang: data.lang || lang,
        context: data.context || null,
      };
    } catch (error) {
      console.error("SOVAH chat fetch error:", error);
      return fallbackFlow(message, lang);
    }
  }

  function mount() {
    if (document.getElementById("sovah-chat-bubble")) return;

    const historyStore = createHistoryStore();
    const contextStore = createContextStore();
    const supportedLangs = ["nl", "en", "de"];
    const storefrontLocale = String(
      (window.Shopify && window.Shopify.locale) ||
      document.documentElement.lang ||
      navigator.language ||
      "en"
    ).toLowerCase().split("-")[0];
    let currentLang = supportedLangs.includes(storefrontLocale)
      ? storefrontLocale
      : detectLang(navigator.language || "en", "en");
    if (!supportedLangs.includes(currentLang)) currentLang = "en";

    const bubble = el("button", {
      id: "sovah-chat-bubble",
      type: "button",
      "aria-label": COPY[currentLang].openAria,
    });

    bubble.innerHTML = `
      <span class="sovah-bubble-logo" aria-hidden="true">
        <img src="${SOVAH_LOGO_URL}" alt="SOVAH logo" />
      </span>
    `;

    const teaser = el("div", { id: "sovah-chat-teaser", "data-open": "false" });
    const teaserOpen = el("button", {
      id: "sovah-chat-teaser-open",
      type: "button",
      "aria-label": COPY[currentLang].teaserAria,
    });
    const teaserAvatar = createAvatar();
    const teaserCopy = el("span", { class: "sovah-chat-teaser-copy" });
    const teaserTitle = el("strong");
    const teaserText = el("span");
    teaserCopy.appendChild(teaserTitle);
    teaserCopy.appendChild(teaserText);
    teaserOpen.appendChild(teaserAvatar);
    teaserOpen.appendChild(teaserCopy);

    const teaserDismiss = el("button", {
      id: "sovah-chat-teaser-dismiss",
      type: "button",
      "aria-label": COPY[currentLang].dismissTeaserAria,
    });
    teaserDismiss.textContent = "×";
    teaser.appendChild(teaserOpen);
    teaser.appendChild(teaserDismiss);

    const panel = el("div", { id: "sovah-chat-panel", "data-open": "false" });

    const header = el("div", { id: "sovah-chat-header" });

    const close = el("button", {
      id: "sovah-chat-close",
      type: "button",
      "aria-label": COPY[currentLang].closeAria,
    });
    close.textContent = "×";

    const titleStrong = el("strong", { html: COPY[currentLang].title });
    const titleSpan = el("span", { html: COPY[currentLang].subtitle });

    const title = el("div", { id: "sovah-chat-title" }, [
      titleStrong,
      titleSpan,
    ]);

    const languageSwitch = el("div", { id: "sovah-language-switch", "aria-label": "Language" });
    const languageButtons = {};

    [
      { lang: "nl", label: "🇳🇱 NL" },
      { lang: "de", label: "🇩🇪 DE" },
      { lang: "en", label: "🇬🇧 EN" },
    ].forEach((item) => {
      const btn = el("button", {
        class: "sovah-lang-btn",
        type: "button",
        "data-lang": item.lang,
      });

      btn.textContent = item.label;
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        currentLang = item.lang;
        refreshUiLanguage(true);
        input.focus();
      });

      languageButtons[item.lang] = btn;
      languageSwitch.appendChild(btn);
    });

    header.appendChild(close);
    header.appendChild(title);
    header.appendChild(languageSwitch);

    const body = el("div", { id: "sovah-chat-body" });
    const footer = el("div", { id: "sovah-chat-footer" });

    const quickPrimaryWrap = el("div", { id: "sovah-quick-primary" });
    const quickSecondaryWrap = el("div", { id: "sovah-quick-secondary" });

    const sessionId = "sovah_" + Math.random().toString(16).slice(2);

    async function runQuickPrompt(prompt) {
      historyStore.pushUser(prompt);
      appendMsg(body, prompt, "user");

      const typingEl = appendTyping(body);
      const minDelay = 800;

      const start = Date.now();
      const out = await callBackend(prompt, sessionId, historyStore, contextStore, currentLang);

      const elapsed = Date.now() - start;
      if (elapsed < minDelay) {
        await new Promise((r) => setTimeout(r, minDelay - elapsed));
      }

      typingEl.remove();

      if (out.lang) {
        currentLang = ["nl", "en", "de"].includes(out.lang) ? out.lang : currentLang;
        refreshUiLanguage();
      }

      appendMsg(body, out.reply, "bot");
      historyStore.pushBot(out.reply);
      appendActions(body, out.actions || [], currentLang);
      appendRoutineCardFallback(body, out.reply, out.actions || [], currentLang);
    }

    function refreshUiLanguage(updateWelcome = false) {
      bubble.setAttribute("aria-label", COPY[currentLang].openAria);
      close.setAttribute("aria-label", COPY[currentLang].closeAria);
      titleStrong.innerHTML = COPY[currentLang].title;
      titleSpan.innerHTML = COPY[currentLang].subtitle;
      input.setAttribute("placeholder", COPY[currentLang].inputPlaceholder);
      send.textContent = COPY[currentLang].send;
      teaserTitle.textContent = COPY[currentLang].teaserTitle;
      teaserText.textContent = COPY[currentLang].teaserText;
      teaserOpen.setAttribute("aria-label", COPY[currentLang].teaserAria);
      teaserDismiss.setAttribute("aria-label", COPY[currentLang].dismissTeaserAria);

      if (typeof languageButtons !== "undefined") {
        Object.entries(languageButtons).forEach(([lang, btn]) => {
          btn.setAttribute("aria-pressed", lang === currentLang ? "true" : "false");
          btn.classList.toggle("is-active", lang === currentLang);
        });
      }

      if (updateWelcome) {
        const welcomeMsg = body.querySelector('[data-sovah-welcome="1"] .sovah-msg.bot');
        if (welcomeMsg) {
          welcomeMsg.innerHTML = renderBotHtml(COPY[currentLang].welcome);
        }
      }

      quickPrimaryWrap.innerHTML = "";
      quickSecondaryWrap.innerHTML = "";

      COPY[currentLang].quickPrimary.forEach((item) => {
        const className =
          item.kind === "quiz"
            ? "sovah-quick-card sovah-quick-card-quiz"
            : "sovah-quick-card";

        const btn = el("button", {
          class: className,
          type: "button",
        });

        const title = el("span", { class: "sovah-quick-card-title" });
        title.textContent = item.label;
        btn.appendChild(title);

        btn.addEventListener("click", async (e) => {
          e.stopPropagation();
          await runQuickPrompt(item.prompt);
        });

        quickPrimaryWrap.appendChild(btn);
      });

      COPY[currentLang].quickSecondary.forEach((item, index) => {
        const chip = el("button", {
          class: index === 1 ? "sovah-mini-chip sovah-mini-chip-accent" : "sovah-mini-chip",
          type: "button",
        });
        chip.textContent = item.label;

        chip.addEventListener("click", async (e) => {
          e.stopPropagation();
          await runQuickPrompt(item.prompt);
        });

        quickSecondaryWrap.appendChild(chip);
      });
    }

    const inputRow = el("div", { id: "sovah-input-row" });
    const input = el("input", {
      id: "sovah-input",
      type: "text",
      placeholder: COPY[currentLang].inputPlaceholder,
    });

    const send = el("button", { id: "sovah-send", type: "button" });
    send.textContent = COPY[currentLang].send;

    inputRow.appendChild(input);
    inputRow.appendChild(send);

    footer.appendChild(quickPrimaryWrap);
    footer.appendChild(quickSecondaryWrap);
    footer.appendChild(inputRow);

    panel.appendChild(header);
    panel.appendChild(body);
    panel.appendChild(footer);

    document.body.appendChild(bubble);
    document.body.appendChild(teaser);
    document.body.appendChild(panel);

    refreshUiLanguage();

    function openChat() {
      hideTeaser();
      panel.setAttribute("data-open", "true");

      if (!body.dataset.welcomed) {
        const storedHistory = historyStore.getAll();

        if (storedHistory.length) {
          storedHistory.forEach((item) => {
            const userMatch = item.match(/^User:\s*([\s\S]*)$/i);
            const assistantMatch = item.match(/^Assistant:\s*([\s\S]*)$/i);

            if (userMatch) {
              appendMsg(body, userMatch[1], "user");
            } else if (assistantMatch) {
              appendMsg(body, assistantMatch[1], "bot");
            }
          });
        } else {
          const welcomeRow = appendMsg(body, COPY[currentLang].welcome, "bot");
          welcomeRow.setAttribute("data-sovah-welcome", "1");
          historyStore.pushBot(COPY[currentLang].welcome);
        }

        body.dataset.welcomed = "1";
      }

      input.focus();
    }

    function closeChat() {
      panel.classList.add("sovah-closing");
      setTimeout(() => {
        panel.setAttribute("data-open", "false");
        panel.classList.remove("sovah-closing");
      }, 160);
    }

    function showTeaser() {
      const isOpen = panel.getAttribute("data-open") === "true";
      if (!isOpen) teaser.setAttribute("data-open", "true");
    }

    function hideTeaser() {
      teaser.setAttribute("data-open", "false");
    }

    function autoOpenChatWithCooldown() {
      const scheduleTeaser = () => {
        setTimeout(() => {
          const isOpen = panel.getAttribute("data-open") === "true";
          if (!isOpen) showTeaser();
        }, SOVAH_TEASER_DELAY);
      };

      try {
        const now = Date.now();
        const lastOpened = parseInt(localStorage.getItem(SOVAH_AUTO_OPEN_KEY) || "0", 10);

        if (lastOpened && now - lastOpened < SOVAH_AUTO_OPEN_COOLDOWN) {
          return;
        }

        localStorage.setItem(SOVAH_AUTO_OPEN_KEY, String(now));
        scheduleTeaser();
      } catch (e) {
        scheduleTeaser();
      }
    }

    bubble.addEventListener("click", (e) => {
      e.stopPropagation();
      hideTeaser();
      const isOpen = panel.getAttribute("data-open") === "true";
      if (isOpen) closeChat();
      else openChat();
    });

    teaserOpen.addEventListener("click", (e) => {
      e.stopPropagation();
      openChat();
    });

    teaserDismiss.addEventListener("click", (e) => {
      e.stopPropagation();
      hideTeaser();
    });

    teaser.addEventListener("click", (e) => {
      e.stopPropagation();
    });

    close.addEventListener("click", (e) => {
      e.stopPropagation();
      closeChat();
    });

    panel.addEventListener("click", (e) => {
      e.stopPropagation();
    });

    async function sendMessage() {
      const text = input.value.trim();
      if (!text) return;

      currentLang = detectLang(text, currentLang);
      refreshUiLanguage();

      input.value = "";
      historyStore.pushUser(text);
      appendMsg(body, text, "user");

      const typingEl = appendTyping(body);
      const minDelay = 800;

      const start = Date.now();
      const out = await callBackend(text, sessionId, historyStore, contextStore, currentLang);

      const elapsed = Date.now() - start;
      if (elapsed < minDelay) {
        await new Promise((r) => setTimeout(r, minDelay - elapsed));
      }

      typingEl.remove();

      if (out.lang) {
        currentLang = ["nl", "en", "de"].includes(out.lang) ? out.lang : currentLang;
        refreshUiLanguage();
      }

      appendMsg(body, out.reply, "bot");
      historyStore.pushBot(out.reply);
      appendActions(body, out.actions || [], currentLang);
      appendRoutineCardFallback(body, out.reply, out.actions || [], currentLang);
    }

    send.addEventListener("click", (e) => {
      e.stopPropagation();
      sendMessage();
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") sendMessage();
    });

    document.addEventListener("click", (e) => {
      const isOpen = panel.getAttribute("data-open") === "true";
      if (!isOpen) return;

      const target = e.target;
      const clickedInsidePanel = panel.contains(target);
      const clickedBubble = bubble.contains(target);

      if (!clickedInsidePanel && !clickedBubble) {
        closeChat();
      }
    });

    autoOpenChatWithCooldown();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mount);
  } else {
    mount();
  }
})();
